// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2lqWX","rightAdornment":"Header_rightAdornment__33Vi9"};